import { IconDictionary } from "./types";

/**
 * The design-provided badge icons. Authored on a 64x64 canvas, they are the
 * only icons the Badge component accepts. Single source of truth for both the
 * Badge component's allowlist and the Icon component's viewBox handling.
 */
export const BADGE_ICONS = [
  "badge_bolt",
  "badge_compass",
  "badge_crown",
  "badge_diamond",
  "badge_heart",
  "badge_peak",
  "badge_rocket",
  "badge_star",
  "badge_trophy",
] as const satisfies readonly IconDictionary[];

export type BadgeIcon = (typeof BADGE_ICONS)[number];
